import {} from "../../request/api";
const state = {
    infoId: null,
    typeRouter: localStorage.getItem('typeRouter') ? localStorage.getItem('typeRouter') : null,
    Flightmissionid: null,
};
const mutations = {
    changeInfoId(state, id) {
        state.infoId = id;
    },
    changetypeRouter(state, type) {
        localStorage.setItem('typeRouter', type);
        state.typeRouter = type;
    },
    changeFlightmissionid(state, type) {
        state.Flightmissionid = type;
    },

};
const actions = {};

const getters = {
    infoId(state) {
        return state.infoId;
    },
    typeRouter(state) {
        return state.typeRouter;
    },
    Flightmissionid(state) {
        return state.Flightmissionid;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
    // 命名空间
    namespaced: true, //使用命名空间
}